import React from 'react';
import FilterCommon, { useFilterCommon } from '@opm/components/FilterCommon';
import MarketContentBody from '@opm/components/MarketContentBody';
import { DBO_TM } from '@op/utils/format';
import { useVideoTableData } from '../../hooks';
import VideoTableList from '../../VideoTable';
import { useScrollBottomRegister } from '@opm/components/ScrollBottomList';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import { VideoPoint } from '@opm/operationLog/pages';

interface ITiktokTabProps {
  backCondConfig: any;
  translateCategory: (value: string, isEn: boolean) => string;
}

export default function TiktokTab({
  backCondConfig,
  translateCategory,
}: ITiktokTabProps) {
  // 页面进入埋点：tea Tabs destroyInactiveTabPanel=true，每次激活本 tab 都会重新触发
  DBOM_POINT.useInitPage({ buriedPoint: VideoPoint, pageExtInfo: 'tiktok' });

  const { filterRef, filter, setFilter, loading, ...filterProps } =
    useFilterCommon({
      keys: [
        'MultiDateRange',
        'VideoCategory',
        'VideoCountryRegion',
        'VideoRelatedLanguages',
      ],
    });

  const { nextPage, resetData, operation, ...props } = useVideoTableData({
    filter: filterRef.current,
    translateCategory,
    channel: 'tiktok',
  });

  useScrollBottomRegister(nextPage);

  const handleConfirm = (value: any) => {
    setFilter({ ...value, channels: ['tiktok'] });
    resetData();
  };

  return (
    <MarketContentBody
      loading={loading}
      filterSlot={
        <FilterCommon
          {...filterProps}
          userDefaultValue={{
            ...DBO_TM.filterRangeDay(6, 0),
            date_type: 'daily',
          }}
          realTimeMode
          filterConfigProps={{
            VideoCategory: {
              channelFilterValue: 'tiktok',
            },
          }}
          confirm={handleConfirm}
          backCondConfig={backCondConfig}
        />
      }
    >
      <VideoTableList operation={operation} {...props} />
    </MarketContentBody>
  );
}
